import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/movie-home/clock.svg'
import _imports_1 from '@/assets/images/movie-home/arrow1.svg'
import _imports_2 from '@/assets/images/movie-home/arrow2.svg'


const _hoisted_1 = { class: "movie-home-slider-area" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-12" }
const _hoisted_5 = {
  class: "movie-home-slider-content",
  style: {"text-align":"right","direction":"rtl"},
  "data-cue": "slideInLeft"
}
const _hoisted_6 = {
  class: "meta",
  style: {"display":"flex","gap":"10px","padding":"0","list-style":"none","flex-wrap":"wrap"}
}
const _hoisted_7 = { style: {"line-height":"1.3","font-size":"2.8rem","max-width":"100%"} }
const _hoisted_8 = {
  class: "rating-and-clock",
  style: {"display":"flex","align-items":"center","gap":"15px"}
}
const _hoisted_9 = {
  class: "rating",
  style: {"display":"flex","padding":"0","list-style":"none"}
}
const _hoisted_10 = {
  class: "clock",
  style: {"display":"flex","align-items":"center","gap":"5px"}
}
const _hoisted_11 = { class: "col-lg-6 col-md-12" }
const _hoisted_12 = { class: "movie-home-slider-video-btn" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_lightgallery = _resolveComponent("lightgallery")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      speed: 1000,
      autoHeight: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
      },
      pagination: {
        el: '.movie-home-slider-pagination',
        clickable: true,
      },
      modules: _ctx.modules,
      class: "movie-home-slider"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "movie-home-slider-item",
                style: _normalizeStyle({ backgroundImage: `url(${slide.image})` })
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("ul", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide.categories, (category, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              style: {"white-space":"nowrap"}
                            }, [
                              _createVNode(_component_RouterLink, { to: "/channel-list" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(category), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("h1", _hoisted_7, _toDisplayString(slide.title), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(slide.description) + " ", 1),
                          _createVNode(_component_RouterLink, { to: "/services-details" }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createTextVNode("اقرأ المزيد", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("ul", _hoisted_9, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                              return _createElementVNode("li", { key: star }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "ri-star-fill" }, null, -1)
                              ]))])
                            }), 64)),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(slide.rating), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[2] || (_cache[2] = _createElementVNode("img", {
                              src: _imports_0,
                              alt: "clock"
                            }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(slide.duration), 1)
                          ])
                        ]),
                        _cache[3] || (_cache[3] = _createElementVNode("ul", {
                          class: "btn-list",
                          style: {"display":"flex","gap":"15px","padding":"0","list-style":"none"}
                        }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://wa.me/447429916178",
                              target: "_blank",
                              class: "btn"
                            }, [
                              _createElementVNode("span", { class: "border-style" }, "اشترك الآن")
                            ])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://wa.me/447429916178",
                              target: "_blank",
                              class: "btn"
                            }, [
                              _createElementVNode("span", { class: "border-style" }, "تجربة مجانية")
                            ])
                          ])
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_lightgallery, {
                          settings: { speed: 500, plugins: _ctx.plugins }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: slide.trailerUrl,
                              class: "video-btn"
                            }, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("i", { class: "ri-play-fill" }, null, -1)
                            ]))], 8, _hoisted_13)
                          ]),
                          _: 2
                        }, 1032, ["settings"])
                      ])
                    ])
                  ])
                ])
              ], 4)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _cache[5] || (_cache[5] = _createElementVNode("ul", {
          class: "movie-home-slider-button",
          style: {"display":"flex","gap":"10px","list-style":"none"}
        }, [
          _createElementVNode("li", null, [
            _createElementVNode("div", { class: "button-prev" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "arrow1"
              })
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", { class: "button-next" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "arrow2"
              })
            ])
          ])
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "movie-home-slider-pagination" }, null, -1))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}